import React, { Fragment } from 'react';

import { connect } from 'react-redux';

import { AppState, Actions, store, IPageState, DisplayState } from 'appredux';


import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Theme } from "@material-ui/core/styles";
import theme from 'themes';
import Typography from '@material-ui/core/Typography';


import { Tooltip, Icon, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button } from '@material-ui/core';

interface DialogProps extends WithStyles<typeof styles> {
    page: IPageState,
}

interface DialogState {
    open: boolean
}

class DialogUkryjPracownika extends React.Component<DialogProps, DialogState>  {

    //PM 2021-09-17
    constructor(props: DialogProps) {
        super(props, {});
        this.state = {
            open: false
        }
    }

    componentDidUpdate(prevProps: DialogProps) {
        if(this.props.page.openDialogError !== prevProps.page.openDialogError){
            this.setState({open: true})
        }
    }

    closeDialog = () => {
        this.setState({ open: false });
    };


    render() {
        const classes = this.props.classes;
       
        return (
            <>
                <Dialog
                    //disableEscapeKeyDown
                    maxWidth="xs"
                    open={this.state.open}
                    onEscapeKeyDown={this.closeDialog}
                    onBackdropClick={this.closeDialog}
                    fullWidth
                >
                    <DialogTitle disableTypography >
                        <Typography gutterBottom variant="h6" component="h2" 
                            className={`${classes.headline} ${classes.error}`}>
                            <b style={{ textTransform: "lowercase" }}>{'uwaga'}</b>
                        </Typography>
                        <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Wystąpił błąd komunikacji z serwerem"}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {""}
                        </DialogContentText>
                        <DialogContentText className={classes.dialogContentText} >
                            {"Prosimy odswieżyć stronę lub spróbować póżniej"}
                        </DialogContentText>

                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" color="secondary" size="small" className={classes.button}
                            onClick={this.closeDialog}>
                            <b>wróć</b>
                        </Button>
                    </DialogActions>
                </Dialog>
            </>

        );
    }
}

const styles = (theme: Theme) => ({
    primary: {
        color: theme.palette.primary.main
      },
      secondary: {
        color: theme.palette.secondary.main
      },
      error: {
          color: "rgb(244, 67, 54)"
      },
      paddingBottom0: {
        paddingBottom: 0
      },
      headline: {
        //fontFamily: "\"'Open Sans'\", sans-serif",
        lineHeight: "20px",
        //fontSize: "16px",
        //fontWeight: 600
      },
      dialogContentText: {
        color: theme.palette.text.secondary,
        whiteSpace: "pre" as "pre",
        minHeight: "12px",
        marginBottom: '12px'
        //fontSize: "14px"
      },
      button: {
        textTransform: "none" as "none"
    },
});

const mapStateToProps = (state: AppState) => ({
    page: state.pageState,
});

export default connect(mapStateToProps)(withStyles(styles)(DialogUkryjPracownika));

